import { render, staticRenderFns } from "./combaine-company.vue?vue&type=template&id=24a3605b&scoped=true&"
import script from "./combaine-company.vue?vue&type=script&lang=js&"
export * from "./combaine-company.vue?vue&type=script&lang=js&"
import style0 from "./combaine-company.vue?vue&type=style&index=0&id=24a3605b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a3605b",
  null
  
)

export default component.exports